import React, { FC, ReactNode } from 'react';
import { useRLAdminView } from '../../../hooks/useRLAdminView';
import './ViewOnlyForm.scss';

interface ChildrenProps {
    children: ReactNode;
}


const ViewOnlyForm: FC<ChildrenProps> = ({ children }) => {
    const { isReadOnly } = useRLAdminView();

    return (
        <div
            className={`view-only-form ${isReadOnly ? 'view-only-form--active' : ''}`}
            aria-readonly={isReadOnly || undefined}
        >
            {children}
        </div>
    );
};


export const ViewOnlyAllowAction: FC<ChildrenProps> = ({ children }) => {
    return <span className="view-only-form__allow-action">{children}</span>;
};

export const HideForViewOnly: FC<ChildrenProps> = ({ children }) => {
    const { isReadOnly } = useRLAdminView();
    if (isReadOnly) {
        return null;
    }
    return <>{children}</>;
};

export const ShowForViewOnly: FC<ChildrenProps> = ({ children }) => {
    const { isReadOnly } = useRLAdminView();
    if (!isReadOnly) {
        return null;
    }
    return <>{children}</>;
};

export default ViewOnlyForm;
